export const env = {
	BASE_URL: globalThis.ENV_BASE_URL,
	API_BASE_URL: globalThis.ENV_API_BASE_URL,
	OAUTH_CLIENT_ID: globalThis.ENV_OAUTH_CLIENT_ID,
}
